import * as React from 'react'
import HoverMenu from 'material-ui-popup-state/HoverMenu'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import {
  usePopupState,
  bindHover,
  bindMenu,
} from 'material-ui-popup-state/hooks'

import styles from '../styles/MenuAcess.module.scss'

import residencial from "../../public/svg/produtos/residencial.svg"
import bike from "../../public/svg/produtos/bike.svg"
import auto from "../../public/svg/produtos/auto.svg"
import empresarial from "../../public/svg/produtos/empresarial.svg"
import odontologico from "../../public/svg/produtos/odontologico.svg"
import vida from "../../public/svg/produtos/vida.svg"
import router from 'next/router'

const MenuPopupState = () => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'demoMenu',
  })
  return (
    <React.Fragment>
      <Button variant="text"  {...bindHover(popupState)}>
        <span className={popupState.isOpen ? styles.menuActive : styles.menuA}>seguros</span>
      </Button>
      <HoverMenu
        {...bindMenu(popupState)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MenuItem onClick={() => {
          popupState.close; router.push({
            pathname: '/seguros/residencial',
          });
        }}>
          <img className={styles.imageMenu} src={residencial} alt="icone do menu para contratação do seguro residencial no portal Madaseg" />
          <span className={styles.linkMenu}>residencial</span>
        </MenuItem>
        <MenuItem onClick={() => {
          popupState.close; router.push({
            pathname: '/seguros/empresarial',
          });
        }}>
          <img className={styles.imageMenu} src={empresarial} alt="icone do menu para contratação do seguro empresarial no portal Madaseg" />
          <span className={styles.linkMenu}>empresarial</span>
        </MenuItem>
        <MenuItem onClick={() => {
          popupState.close; router.push({
            pathname: '/seguros/vida',
          });
        }}>
          <img className={styles.imageMenu} src={vida} alt="icone do menu para contratação do seguro vida no portal Madaseg" />
          <span className={styles.linkMenu}>vida</span>
        </MenuItem>
        <MenuItem onClick={() => {
          popupState.close; router.push({
            pathname: '/seguros/odontologico',
          });
        }}>
          <img className={styles.imageMenu} src={odontologico} alt="icone do menu para contratação do plano odontológico no portal Madaseg" />
          <span className={styles.linkMenu}>odontológico</span>
        </MenuItem>
        <MenuItem onClick={() => {
          popupState.close; router.push({
            pathname: '/seguros/bike',
          });
        }}>
          <img className={styles.imageMenu} src={bike} alt="icone do menu para contratação do seguro bike no portal Madaseg" />
          <span className={styles.linkMenu}>bike</span>
        </MenuItem>
        <MenuItem onClick={() => {
          popupState.close; router.push({
            pathname: '/seguros/auto',
          });
        }}>
          <img className={styles.imageMenu} src={auto} alt="icone do menu para contratação do seguro auto no portal Madaseg" />
          <span className={styles.linkMenu}>auto</span>
        </MenuItem>
      </HoverMenu>
    </React.Fragment>
  )
}

export default MenuPopupState